OBSERVED_CHANGED_OPTIONS